// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_8O2","cls2":"UserTaggingPingBodyStyles-cls2_kVl UserTaggingPingBodyStyles-cls1_8O2"};